<div class="container">


  <h2 class="content-heading">
    
    <button class="btn btn-sm btn-outline-secondary float-right" (click)="add()">
      <i class="fa fa-plus mr-5"></i>Add Service
    </button>
  
    Services
  </h2>
 
  <div style="margin-bottom:15px">
    <app-service-search (searchItems)="search($event)"></app-service-search>
  </div>

  <div class="blockX">
 
    <div class=row>
 
      <div class="col-sm-5">

        <!-- Show
        <select (change)="changeNumberOfRecords()" [(ngModel)]="numberOfRecords">
          <option value=15>15</option>
            <option value=30>30</option>
            <option value=60>60</option>
            <option value=99999>All</option>
        </select>
        entries

        <button class="btn" (click)="today()" style="margin-left:25px">Today</button> -->

      </div>


      <div class="col-sm-7 text-right">
        <span style="margin-right:20px">
            Status: 
            <select  (change)="changeStatusOption()" [(ngModel)]="searchStatus">
              <option [ngValue]=null></option>
              <option  [ngValue]=true>Active</option>
              <option  [ngValue]=false>Inactive</option>
            </select>
          </span>

          <span style="margin-right:20px">
              Proofed: 
              <select  (change)="changeProofedOption()" [(ngModel)]="searchProofed">
                <option [ngValue]=null></option>
                <option  [ngValue]=true>Yes</option>
                <option  [ngValue]=false>No</option>
              </select>
            </span>

          Filter: <input type="text" [(ngModel)]="filterName">
      </div> 
      
    </div>

    <div class="table-responsive table yearDataTable" xclass="table table-striped table-vcenter table-sm">

      <div class="xrow header gridRow row">
        <div class="col-md-3X">Name</div>
        <div class="col-md-2X">Season</div>
        <div class="col-md-2X">Text Source</div>
        <div class="col-md-2X">Feast Type</div>
        <div class="col-md-1X">Vestment color</div>
        <div class="col-md-2X">Active</div>
        <div class="col-md-2X">Proofed</div>
        <div class="col-md-2X">Actions</div>
        <div class="scrollPad"></div>
      </div> 
 
      <div id="scrollableTable">
          <div *ngFor="let obj of entities | serviceFilter: filterName:searchProofed:searchStatus" class="dateRow gridRow row">
            <div class="col-md-3X">
              {{obj.Name}}<span *ngIf="obj.SubName != ''" class='subname'>, {{obj.SubName}}</span><span *ngIf="obj.AbbreviatedName != '' && obj.AbbreviatedName != null" class='abbrName'> ({{obj.AbbreviatedName}})</span>
            </div>
            <div class="col-md-2X">{{obj.Season}}</div>
            <div class="col-md-2X">{{obj.LectionarySource}}</div>
            <div class="col-md-2X">{{obj.FeastType}}</div>
            <div class="col-md-1X">{{obj.VestmentColors}}</div>
            <div class="col-md-2X">{{obj.IsActive}}</div>
            <div class="col-md-2X">{{obj.ProofedByValue}}</div>
            <div class="col-md-2x actions">

              <button type="button" class="btn btn-sm btn-secondary js-tooltip-enabled" data-toggle="tooltip" title="" data-original-title="Edit" (click)="edit(obj)">
                <i class="fa fa-pencil"></i>
              </button>
              <button type="button" class="btn btn-sm btn-secondary js-tooltip-enabled" data-toggle="tooltip" title="" data-original-title="Delete" (click)="delete(obj)">
                <i class="fa fa-times"></i>
              </button>

            </div>
          </div>
      </div>
    </div>

    <div>
 
      <div>
        Total Proofed: 
        {{countTotalProofed}}
      </div>
      <div>
        Total Not Proofed:
        {{countTotalNotProofed}}
      </div>
      
    </div>


  </div>


  <app-progress-bar *ngIf="isLoading==true"></app-progress-bar>

</div>
